import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
import {DeepDiveComponent} from "./deep-dive.component";

const routes: Routes = [
	{
		path: "",
		component: DeepDiveComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class DeepDiveRoutingModule {}
